<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: {
                type: Number,
                default: 1,
            },
            label: {
                type: String,
            },
            currency1: {
                type: Number,
                default: 0,
            },
            currency2: {
                type: Number,
                default: 0,
            },
            reverse: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            fixed: {
                type: Number,
                default: 4
            },
            min: {
                type: Number,
                default: 0
            },
            max: {
                type: Number,
                default: 999999999999
            },
        },
        data() {
            return {
                val: '',
                r: this.reverse,
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/currency/get_list'
            }),
            ms(v) {
                let mask = [];
                let a = this.validate(v).replace(/\d/g, '9').split('');
                a.forEach(i => {
                    if (i === '9') mask.push(/\d/);
                    if (i === '.') mask.push(/[\.,]/);
                    if (i === ' ') mask.push(' ');
                });
                return mask;
            },
            validate(v) {
                let parts = v.toString().replace(/ /g, '').replace(/,/g, '.').replace(/^([^\.]*\.)|\./g, '$1').split(".");
                parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
                if (parts[1] && parts[1].length > this.fixed) parts[1] = parts[1].slice(0, this.fixed);
                return parts.join(".");

            },
            change(e) {
                let v = +(this.val.replace(/ /g, '').replace(/,/g, '.'));
                if (this.r && v) {
                    v = 1 / v;
                }
                v = Math.ceil(v * 10000000000000000) / 10000000000000000;
                this.$emit('change', v);
                this.$emit('input', v);
            },
            click_reverse() {
                this.r = !this.r;
                this.$emit('update:valueCurrency', this.r);
                this.set_val();
            },
            set_val() {
                let v = +(this.value);
                if (this.r && v) {
                    v = 1 / v;
                }
                this.val = this.validate(v);
            },
        },
        computed: {
            ...mapState('dictionary/currency', {
                load: 'load',
                list: 'list'
            }),
            ...mapGetters('dictionary/currency', {
                national: 'national',
                getById: 'getById',
            }),
            c1() {
                return this.getById(this.currency1) || {};
            },
            c2() {
                return this.getById(this.currency2) || {};
            },
        },
        watch: {
            value(v) {
                this.set_val();
            },
            reverse(v) {
                this.r = v;
                this.set_val();
            },
        },
        components: {},
        mounted() {
            this.set_val();
            if (this.currency) this.get_list();
        },
        destroyed() {

        },
    }

</script>
<template>
    <div class="input-price" :class="{'is-disabled':disabled}">
        <div class="el-input el-input--mini el-input-group el-input-group--append" :class="{'is-disabled':disabled,'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <masked-input
                    type="text"
                    @change="change"
                    v-model="val"
                    :mask="ms"
                    :guide="false"
                    placeholderChar="#"
                    class="el-input__inner"
                    :disabled="disabled">
            </masked-input>
            <div class="el-input-group__append" @click="click_reverse" v-if="r">{{c1.IsoCode}} / {{c2.IsoCode}}</div>
            <div class="el-input-group__append" @click="click_reverse" v-if="!r">{{c2.IsoCode}} / {{c1.IsoCode}}</div>
        </div>
    </div>
</template>

<style lang="scss">
    .input-price {
        position: relative;
        .el-input-group__append {
            cursor: pointer;
            user-select: none;
        }
        &.is-disabled {
            .el-input-group__append {
                .input-price {
                    &__currency {
                        .el-input {
                            &.is-disabled {
                                .el-input__inner {
                                    cursor: not-allowed;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
